import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { PaymentCompletedDialog } from './PaymentCompletedDialog';
import { ComponentProps, useEffect, useRef, useState } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

export interface StandalonePaymentCompletedDialogProps extends StandaloneComponentProps<typeof PaymentCompletedDialog> {
  content?: React.ReactNode;
  dialog?: ComponentProps<typeof PaymentCompletedDialog.Dialog>;
  queryParamTrigger?: string;
}

export const StandalonePaymentCompletedDialog: StandaloneComponent<StandalonePaymentCompletedDialogProps> = ({
  content,
  dialog,
  queryParamTrigger = 'payment_accepted',
  ...props
}) => {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const [showDialog, setShowDialog] = useState(false);
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    if (searchParams.get(queryParamTrigger)) {
      setShowDialog(true);

      const newSearchParams = new URLSearchParams(searchParams.toString());
      newSearchParams.delete(queryParamTrigger);

      const newUrl = pathname + (newSearchParams.toString() ? '?' + newSearchParams.toString() : '');
      window.history.pushState(null, '', newUrl);
    }
  }, [searchParams, router, pathname]);

  useEffect(() => {
    if (showDialog && dialogRef.current) {
      dialogRef.current.showModal();
    }
  }, [showDialog]);

  return (
    <PaymentCompletedDialog {...props}>
      <PaymentCompletedDialog.Dialog {...dialog} options={{ ...dialog?.options, ref: dialogRef }} />
    </PaymentCompletedDialog>
  );
};
